module.exports = __webpack_public_path__ + "static/t&d-desk-90df9464cc9fb8306e8deb0acb4ed4d7.png";